import React, { memo } from 'react';
import { VARIABLE_COLORS } from '../../../../utils/variableScope';

const ColorDot = memo(({ color, onChange, readOnly }) => {
  if (readOnly) {
    return (
      <span
        className="variables-panel__color-dot variables-panel__color-dot--static"
        style={{ backgroundColor: color || VARIABLE_COLORS[0] }}
        aria-hidden
      />
    );
  }
  const cycle = () => {
    const index = VARIABLE_COLORS.indexOf(color);
    onChange(VARIABLE_COLORS[(index + 1) % VARIABLE_COLORS.length]);
  };
  return (
    <button
      type="button"
      className="variables-panel__color-dot"
      style={{ backgroundColor: color || VARIABLE_COLORS[0] }}
      onClick={cycle}
      title="Change color"
      aria-label="Variable color"
    />
  );
});

export default ColorDot;
